import * as yup from "yup";

export const validationSchema = yup.object({
  accountName: yup
    .string("Select account name")
    .required("Account name is required"),
  type: yup.string("Enter type").required("Type is required"),
  subType: yup.string("Enter sub type").required("Sub type is required"),
  // dateOfComplaint: yup
  //   .string("Enter date of complaint")
  //   .required("Date of complaint is required"),
});
